import styled, { css } from 'styled-components';
import { getTypographyStyles } from '../../utils/index.js';
import { SYS_SIZE_FIXED_25, SYS_SIZE_FIXED_50 } from '../../tokens/sizing.generated.js';
import { SYS_SPACE_FIXED_50 } from '../../tokens/spacing.generated.js';
import { Icon } from '../icon/index.js';
import { CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_NORMAL, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_NORMAL, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_NORMAL, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_BOLD, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_BOLD, CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_BOLD } from '../../tokens/typography.generated.js';
import { SEM_BORDER_WIDTH_NAVIGATION_DEFAULT } from '../../tokens/border-width.generated.js';
const iconSizeMD = '24px';
const iconSizeS = '16px';
export const StyledTextLink = styled.a `
  position: ${(props) => (props.variant === 'inline' ? 'static' : 'relative')};
  display: ${(props) => props.variant === 'inline' ? 'inline-block' : 'inline-flex'};

  // TODO: token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;

  ${(props) => {
    if (props.variant === 'inline' && props.weight === 'bold') {
        return getTypographyStyles(props.size === 'md'
            ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_BOLD
            : props.size === 'sm'
                ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_BOLD
                : CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_BOLD);
    }
    return getTypographyStyles(props.size === 'md'
        ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_MD_LABEL_NORMAL
        : props.size === 'sm'
            ? CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_SM_LABEL_NORMAL
            : CMP_TYPOGRAPHY_NAVIGATION_TEXT_LINK_XS_LABEL_NORMAL);
}}

  ${(props) => props.variant === 'inline' &&
    css `
      transition-property: color, text-decoration-color;
      text-decoration-line: underline;
      text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};
      text-decoration-thickness: ${props.weight === 'normal'
        ? SYS_SIZE_FIXED_25
        : SYS_SIZE_FIXED_50};
      text-decoration-skip-ink: none;

      :hover,
      :active {
        text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
      }

      ${StyledIcon} {
        vertical-align: ${props.size === 'md' ? 'bottom' : 'text-bottom'};
      }
    `}

    ${(props) => props.variant === 'standalone' &&
    css `
      &::before {
        position: absolute;
        display: block;
        content: '';
        height: ${SYS_SIZE_FIXED_50};
        border-bottom: ${SEM_BORDER_WIDTH_NAVIGATION_DEFAULT} solid
          ${props.theme.cmp.color.navigation.textLink.foreground.default};
        // TODO: token
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
        transition-duration: 250ms;
        transition-property: border-color;
        bottom: 0;

        ${props.icon && props.iconPosition
        ? css `
              width: calc(
                100% - ${SYS_SPACE_FIXED_50} -
                  ${props.size === 'md' ? iconSizeMD : iconSizeS}
              );
            `
        : css `
              width: 100%;
            `}

        ${props.iconPosition === 'leading'
        ? css `
              right: 0;
            `
        : css `
              left: 0;
            `}
      }

      &:hover,
      &:active {
        &::before {
          border-color: ${props.theme.cmp.color.navigation.textLink.foreground
        .interactive};
        }
      }
    `}



  color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};

  &:hover,
  &:active {
    color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
  }
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  ${(props) => props.variant === 'standalone' &&
    props.iconPosition === 'leading' &&
    css `
      margin-right: ${SYS_SPACE_FIXED_50};
    `}

  ${(props) => ((props.variant === 'standalone' && props.iconPosition === 'trailing') ||
    props.variant === 'inline') &&
    css `
      margin-left: ${SYS_SPACE_FIXED_50};
    `}
`;
//# sourceMappingURL=index.styles.js.map